export default "__VITE_ASSET__EEU0q3_9__"